module.exports = __webpack_public_path__ + "imgs/card-cover6@1x-min.b6c4848d.webp";